"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slide = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _CurrencyFormat = _interopRequireDefault(require("../../../CurrencyFormat"));
var _constants = require("../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Slide = exports.Slide = function Slide(_ref) {
  var region = _ref.region,
    _onClick = _ref.onClick,
    isActive = _ref.isActive,
    isMobile = _ref.isMobile;
  return /*#__PURE__*/_react["default"].createElement(SlideContainer, {
    className: "swiper-slide",
    onClick: function onClick() {
      return _onClick(region);
    },
    $isMobile: isMobile,
    $isActive: isActive
  }, /*#__PURE__*/_react["default"].createElement(StyledBackground, {
    $isActive: isActive
  }), /*#__PURE__*/_react["default"].createElement(RegionText, null, region.name), /*#__PURE__*/_react["default"].createElement(_CurrencyFormat["default"], {
    prefix: "\u043E\u0442 ",
    value: region.min_price
  }));
};
var StyledBackground = _styledComponents["default"].div.withConfig({
  displayName: "Slide__StyledBackground",
  componentId: "sc-l5hw4z-0"
})(["position:absolute;top:0px;z-index:-1;width:100%;height:85%;background-color:", ";border-radius:var(--border-radius) var(--border-radius) 5px 5px;"], function (_ref2) {
  var $isActive = _ref2.$isActive;
  return $isActive ? 'var(--secondary)' : 'transparent';
});
var SlideContainer = _styledComponents["default"].div.withConfig({
  displayName: "Slide__SlideContainer",
  componentId: "sc-l5hw4z-1"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;position:relative;user-select:none;height:", "px;padding-bottom:calc(", "px * 0.15);width:min-content;min-width:", "px;padding:8px 4px;color:", ";font-size:14px;line-height:16px;font-style:normal;font-weight:500;", " &:after{content:'';position:absolute;box-sizing:content-box;bottom:0.2px;z-index:-1;width:calc(100% - 7px);height:15%;clip-path:polygon(0 0,100% 0,50% 100%);;background-color:", ";}"], _constants.SWIPER_HEIGHT, _constants.SWIPER_HEIGHT, function (_ref3) {
  var $isMobile = _ref3.$isMobile;
  return $isMobile ? 100 : 130;
}, function (_ref4) {
  var $isActive = _ref4.$isActive;
  return $isActive ? 'var(--white)' : 'var(--black)';
}, function (_ref5) {
  var $isActive = _ref5.$isActive;
  return !$isActive && (0, _styledComponents.css)(["cursor:pointer;"]);
}, function (_ref6) {
  var $isActive = _ref6.$isActive;
  return $isActive ? 'var(--secondary)' : 'transparent';
});
var RegionText = _styledComponents["default"].div.withConfig({
  displayName: "Slide__RegionText",
  componentId: "sc-l5hw4z-2"
})(["text-align:center;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;white-space:pre-line;"]);